import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  InventoryDefectHistoryDetailItem,
  InventoryDefectHistoryDetailReqParams,
  InventoryDefectHistoryItem,
  InventoryDefectHistoryReqParams,
  InventoryHistoryDetailItem,
  InventoryHistoryDetailReqParams,
  InventoryHistoryItem,
  InventoryHistoryReqParams,
} from '@/services/inventory/inventory.types'
import {
  getInventoryDefectHistory,
  getInventoryDefectHistoryDetail,
  getInventoryHistory,
  getInventoryHistoryDetail,
} from '@/services/inventory/apis'

export const PAGE_SIZE_ON_INVENTORY = 10000

const GET_INVENTORY_HISTORY = ['IV02', 'GET_INVENTORY_HISTORY']
const GET_INVENTORY_HISTORY_DETAIL = ['IV02', 'GET_INVENTORY_HISTORY_DETAIL']
const GET_INVENTORY_DEFECT_HISTORY = ['IV03', 'GET_INVENTORY_DEFECT_HISTORY']
const GET_INVENTORY_DEFECT_HISTORY_DETAIL = ['IV03', 'GET_INVENTORY_DEFECT_HISTORY_DETAIL']

/** `data` 를 빈 배열로 채워 내보내는 훅의 반환 타입. */
type ListQueryResult<T> = Omit<UseQueryResult<T[], Error>, 'data'> & { data: T[] }

export const useInventoryHistory = (params: InventoryHistoryReqParams): ListQueryResult<InventoryHistoryItem> => {
  const { data, ...rest } = useQuery({
    // 조건을 키에 넣는다 — 그리드에 보이는 데이터가 항상 그 조건의 결과가 되어 엑셀 조건과 어긋나지 않는다.
    queryKey: [...GET_INVENTORY_HISTORY, params],
    queryFn: async () => (await getInventoryHistory(params)).data?.items ?? [],
    enabled: false,
  })

  return {
    ...rest,
    data: data ?? [],
  }
}

export const useInventoryHistoryDetail = (params: InventoryHistoryDetailReqParams): ListQueryResult<InventoryHistoryDetailItem> => {
  const { data, ...rest } = useQuery({
    queryKey: [...GET_INVENTORY_HISTORY_DETAIL, params],
    queryFn: async () => (await getInventoryHistoryDetail(params)).data?.items ?? [],
    enabled: false,
  })

  return {
    ...rest,
    data: data ?? [],
  }
}
export const useInventoryDefectHistory = (params: InventoryDefectHistoryReqParams): ListQueryResult<InventoryDefectHistoryItem> => {
  const { data, ...rest } = useQuery({
    queryKey: [...GET_INVENTORY_DEFECT_HISTORY, params],
    queryFn: async () => (await getInventoryDefectHistory(params)).data?.items ?? [],
    enabled: false,
  })

  return {
    ...rest,
    data: data ?? [],
  }
}

export const useInventoryDefectHistoryDetail = (
  params: InventoryDefectHistoryDetailReqParams,
): ListQueryResult<InventoryDefectHistoryDetailItem> => {
  const { data, ...rest } = useQuery({
    queryKey: [...GET_INVENTORY_DEFECT_HISTORY_DETAIL, params],
    queryFn: async () => (await getInventoryDefectHistoryDetail(params)).data?.items ?? [],
    enabled: false,
  })

  return {
    ...rest,
    data: data ?? [],
  }
}
